import React from 'react';
import { cond, is, find, prop, propEq, sortBy } from 'ramda';
import {useIntl} from 'gatsby-plugin-intl';

import { Container, Title, CardWrapper, Card, CardContent } from './cardGrid.styles';
import { CardCarousel } from '../cardCarousel';
import { renderWhenTrueOtherwise } from '../../utils/rendering';
import { useBreakpointsContext } from '../../store/BreakpointsContext';

const renderTitle = ({ value }, key, isDesktop) => {
  const { formatMessage } = useIntl();
  return (isDesktop ? null : <Title key={key}>{formatMessage({id:value})}</Title>);
};

const renderCardContent = ({ type, value }, key) => {
  if (!value || !is(String, value)) return null;
  const { formatMessage } = useIntl();
  return (
    <CardContent type={type} key={key}>
      {formatMessage({ id: value })}
    </CardContent>
  );
};

const renderCard = ({ elements = [] }, key) => (
  <Card key={key}>{sortBy(prop('order'))(elements).map(renderCardContent)}</Card>
);

const renderCards = ({ value = [] }, key) => (
  <CardWrapper key={key}>{sortBy(prop('order'))(value).map(renderCard)}</CardWrapper>
);

const renderElement = cond([
  [propEq('name', 'Title'), renderTitle],
  [propEq('name', 'Card'), renderCards],
]);

export const CardGrid = ({ elements }) => {
  const orderedElements = sortBy(prop('order'))(elements);
  const { value: cardType = 'short' } = find(propEq('name', 'Width (short or wide)'))(orderedElements) || {};
  const { isDesktop } = useBreakpointsContext();

  const renderCards = () => (
    <Container cardType={cardType}>
      {orderedElements.map((value, key) => renderElement(value, key, isDesktop))}
    </Container>
  );

  const renderCarousel = () => <CardCarousel elements={elements} />;

  const mainContent = renderWhenTrueOtherwise(renderCards, renderCarousel);

  return mainContent(isDesktop);
};
